import { Component } from '@angular/core'
import { MatDivider } from '@angular/material/divider'
import { RouterLink } from '@angular/router'
import { ElderNavLinkComponent, ElderNavListComponent } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-main-nav-menu',
  imports: [ElderNavListComponent, ElderNavLinkComponent, RouterLink, MatDivider],
  templateUrl: './main-nav-menu.component.html',
})
export class MainNavMenuComponent {}
